import React, { useEffect, useState } from 'react';
import theme from './ConfirmMeeting.module.scss';
import SplashPage from './SplashPage';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { confirmMeetingForBuyer } from '@/services/booking';
import { Trans } from '@lingui/react/macro';
import { useQueryString } from '@/utils/hooks';
import { useLocation } from 'react-router';

export interface ConfirmMeetingProps {}

interface QueryString {
    token?: string;
}

enum ConfirmStatus {
    Loading,
    Success,
    Failed,
}

export const ConfirmMeeting: React.FC<ConfirmMeetingProps> = ({}) => {
    const location = useLocation();
    const { token } = useQueryString<QueryString>(location);
    const [status, setStatus] = useState(ConfirmStatus.Loading);
    useEffect(() => {
        async function confirm() {
            if (token) {
                setStatus(ConfirmStatus.Loading);
                try {
                    await confirmMeetingForBuyer(token);
                    setStatus(ConfirmStatus.Success);
                } catch {
                    setStatus(ConfirmStatus.Failed);
                }
            }
        }

        confirm();
    }, [token]);

    const renderContent = () => {
        if (status === ConfirmStatus.Loading) {
            return <LoadingIndicator />;
        } else if (status === ConfirmStatus.Success) {
            return (
                <h3>
                    <Trans>Meeting time confirmed</Trans>
                </h3>
            );
        } else if (status === ConfirmStatus.Failed) {
            return (
                <h3>
                    <Trans>Meeting time could not be confirmed</Trans>
                </h3>
            );
        }
    };

    return <SplashPage>{renderContent()}</SplashPage>;
};
